/** An order's own page gives each tab its own route, `/maintenance/work-orders/:id/<tab>` (`recordTabRoutes`). */
export const WORK_ORDER_TABS = ['details', 'history', 'verification'] as const;
export type WorkOrderTab = (typeof WORK_ORDER_TABS)[number];

export const WORK_ORDER_TAB_LABELS: Record<WorkOrderTab, string> = { details: 'Details', history: 'History', verification: 'Verification' };

/** Orders live under the Work orders tab so the sidebar keeps Maintenance highlighted. */
export function workOrderPath(id: string): string {
  return `/maintenance/work-orders/${id}`;
}

export function workOrderTabPath(id: string, tab: WorkOrderTab): string {
  return `${workOrderPath(id)}/${tab}`;
}
